import {useTheme} from "@mui/material";
import Grid from "@mui/material/Grid";

import Box from "@mui/material/Box";

import * as React from "react";
import HalfPieChart from "../../../components/Charts/HalfPieChart";
import DoubleAreaChart from "../../../components/Charts/DoubleAreaChart";
import StatsCard from "../../../components/Card/StatsCard";
import {useRefinitivStatsData} from "../../../hooks/refinitiv";

const StatsLoading = () => (
    <Box sx={{
        height: 160,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '.95rem'
    }}>Loading...</Box>
);

export default () => {
    const stats = useRefinitivStatsData();
    const theme = useTheme();

    let collectionStatus;
    let deliveryStatus;
    if (!stats.isLoading && !stats.error) {
        collectionStatus = stats.data['today_collection_status'].map(val => {
            const obj = {...val};
            if (val.status === 'Success') {
                obj.fill = theme.palette.success.light;
            } else {
                obj.fill = theme.palette.error.light;
            }
            obj.fillOpacity = .95;
            return obj
        });

        deliveryStatus = stats.data['today_delivery_status'].map(val => {
            const obj = {...val};
            if (val.status === 'Success') {
                obj.fill = theme.palette.success.light;
            } else {
                obj.fill = theme.palette.error.light;
            }
            obj.fillOpacity = .95;
            return obj
        });
    }


    return (
        <Grid container columnSpacing={2}>
            <Grid item sm={12} md={6} lg={4} sx={{mb: 2}}>
                <StatsCard loading={stats.isLoading} title="Collection Status" subtitle="Today"
                           linkTo="/status">
                    {
                        stats.status === 'success' &&
                        <HalfPieChart height={160} data={collectionStatus}/>
                    }
                    {
                        stats.isLoading &&
                        <StatsLoading/>
                    }
                </StatsCard>
            </Grid>
            <Grid item sm={12} md={6} lg={4} sx={{mb: 2}}>
                <StatsCard loading={stats.isLoading} title="Recent Delivery Status" subtitle="Today"
                           linkTo="/recent">
                    {
                        stats.status === 'success' &&
                        <HalfPieChart height={160} data={deliveryStatus}/>
                    }
                    {
                        stats.isLoading &&
                        <StatsLoading/>
                    }
                </StatsCard>
            </Grid>
            <Grid item sm={12} md={12} lg={4} sx={{mb: 2}}>
                <StatsCard loading={stats.isLoading} title="Deliveries Over Time" subtitle="Past 7 Days"
                           linkTo="/deliveries">
                    {
                        stats.status === 'success' &&
                        <DoubleAreaChart height={160} data={stats.data['deliveries_timeline']}
                                         color1={theme.palette.success.light} color2={theme.palette.error.light}/>
                    }
                    {
                        stats.isLoading &&
                        <StatsLoading/>
                    }
                </StatsCard>
            </Grid>
        </Grid>
    )
}